export default "__VITE_ASSET__5Po7phKH__"